module.exports = __webpack_public_path__ + "images/background/image_thumbnail/2-on-5b343771087700d03f171bf50b90b950.jpg";